import React from 'react';
import Icon from '../../../components/AppIcon';

const VerificationLoading = () => {
  return (
    <div className="clinical-card p-8 text-center">
      {/* Loading Animation */}
      <div className="w-20 h-20 mx-auto mb-6 relative">
        <div className="w-full h-full border-4 border-primary border-t-transparent rounded-full animate-spin"></div>
        <div className="absolute inset-0 flex items-center justify-center">
          <Icon name="Mail" size={32} color="var(--color-primary)" />
        </div>
      </div>

      {/* Loading Message */}
      <h2 className="text-2xl font-bold text-foreground mb-3">
        Verifying Your Email
      </h2>
      
      <p className="text-muted-foreground mb-6">
        Please wait while we confirm your email address...
      </p>

      {/* Progress Steps */}
      <div className="space-y-3 mb-6">
        <div className="flex items-center gap-3 text-sm">
          <div className="w-6 h-6 bg-primary rounded-full flex items-center justify-center flex-shrink-0">
            <Icon name="Check" size={14} color="white" />
          </div>
          <span className="text-foreground">Checking verification link</span>
        </div>
        
        <div className="flex items-center gap-3 text-sm">
          <div className="w-6 h-6 border-2 border-primary rounded-full flex items-center justify-center flex-shrink-0 animate-pulse">
            <div className="w-2 h-2 bg-primary rounded-full"></div>
          </div>
          <span className="text-muted-foreground">Validating credentials</span>
        </div>
        
        <div className="flex items-center gap-3 text-sm">
          <div className="w-6 h-6 border-2 border-border rounded-full flex-shrink-0"></div>
          <span className="text-muted-foreground">Activating account</span>
        </div>
      </div>

      {/* Security Badge */}
      <div className="flex items-center justify-center gap-2 text-xs text-muted-foreground">
        <Icon name="Shield" size={14} color="#10b981" />
        <span>Secure verification in progress</span>
      </div>
    </div>
  );
};

export default VerificationLoading;